import { OnInit } from '@angular/core';
import { AuthService } from '../shared/auth.service';
import { Role } from '../shared/Roles';
import { AccountServiceProxy } from '../service-proxies';
import { ProfilePictureService } from '../shared/utils/profile-picture.service';
import { AppTranslationService } from '../shared/app-translation.service';
import { NgxSpinnerService } from 'ngx-spinner';
var HeaderComponent = /** @class */ (function () {
    function HeaderComponent(_authService, _account, _languageService, _profile, _SpinnerService) {
        this._authService = _authService;
        this._account = _account;
        this._languageService = _languageService;
        this._profile = _profile;
        this._SpinnerService = _SpinnerService;
        this.logo = 'assets/img/newlogo.png';
        this.isLoggedin = false;
        this.role = Role;
    }
    HeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.profilePicture = 'assets/img/default-profile-picture.png';
        this.isLoggedin = this._authService.isLoggedIn;
        if (this.isLoggedin) {
            this.userName = this._authService.currentUserName;
            this.getProfilePicture();
        }
        this._profile.changeEvent.subscribe(function (result) {
            _this.getProfilePicture();
        });
    };
    HeaderComponent.prototype.getProfilePicture = function () {
        var _this = this;
        this._account.getUserProfilePicture(this._authService.userId).subscribe(function (result) {
            if (result.profilePicture) {
                _this.profilePicture = 'data:image/jpeg;base64,' + result.profilePicture;
            }
            else {
                _this.profilePicture = 'assets/img/default-profile-picture.png';
            }
        });
    };
    HeaderComponent.prototype.changeLanguage = function (lang) {
        this._authService.setLanguage(lang);
        window.location.reload();
    };
    HeaderComponent.prototype.logout = function () {
        this._SpinnerService.show();
        this._authService.logout();
    };
    Object.defineProperty(HeaderComponent.prototype, "userRole", {
        get: function () {
            return this._authService.userRole.toLowerCase();
        },
        enumerable: true,
        configurable: true
    });
    HeaderComponent.prototype.isGranted = function (role) {
        if (this._authService.userRole.toLowerCase() === role.toLowerCase()) {
            return true;
        }
        else {
            return false;
        }
    };
    return HeaderComponent;
}());
export { HeaderComponent };
